/*
 * Who the CARFAX features are withheld from.
 *
 * ⚠ One definition, because the answer now decides whether a BUTTON is drawn as well as whether a
 * prompt interrupts, and three screens have to agree about it. The predicate itself is unchanged -
 * this is the same body the inventory mixin and ApprovePpaAction each carried their own copy of.
 */
export const hasCarfaxTesterRole = (currentUser) => {
  /*
   * ⚠ TRUE when the roles have not loaded, which is the existing behaviour and is deliberately
   * preserved: it fails closed, so nothing CARFAX-related is offered to a user whose roles are not
   * known yet. It is also why the prompt can be intermittently missing on a slow load - a defect
   * already on record, and not one to change while moving the code.
   */
  if (currentUser && currentUser.roles) {
    return currentUser.roles.find((x) => { return x.name.toLowerCase().includes('carfax tester') }) !== undefined
  }
  return true
}
